import {Component, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {
	buildConfigurationRequestForm,
	ConfigurationRequestForm
} from '@app/modules/equipments/configurator/equipment-configuration/pipes/configuration-request-form.model';
import {map, Observable} from 'rxjs';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UserInfo} from '@app/model/user-info.model';

export interface ArticleListSaveDialogData {
	userInfo$: Observable<UserInfo>;
}

@Component({
	selector: 'app-save-configuration-dialog',
	templateUrl: './save-configuration-dialog.component.html',
	styleUrls: ['./save-configuration-dialog.component.scss']
})
export class SaveConfigurationDialogComponent {
	configurationRequestForm: FormGroup<ConfigurationRequestForm> = buildConfigurationRequestForm();
	canShareGlobally$!: Observable<boolean>;

	constructor(@Inject(MAT_DIALOG_DATA) public data: ArticleListSaveDialogData) {
		this.canShareGlobally$ = data.userInfo$.pipe(
			map(userInfo => userInfo.roles.includes('SHARE_CONFIGURATIONS_GLOBALLY'))
		);
	}
}
